import React from "react";
import Topbar from "../topBar";
import Sidebar from "../sideBar";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Cookies from "universal-cookie";
import { getOrganisation } from "../../actions/adminAction";
import { useState, useEffect } from "react";
import {
  voucherList,
  addVocher,
  editVocher,
  deleteVocher,
  assignVocher
} from "../../actions/settingsAction";
import { AdminSubscription } from "../../actions/subscriptionsActions";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { EDIT } from "../../constants/url";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Modal,
  Box,
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TableRow,
} from "@mui/material";
import { FiEdit2 } from "react-icons/fi";
import { FaRegThumbsUp, FaRegThumbsDown } from "react-icons/fa";
import { ERR_ALERT_TITLE, ERR_GETTING, VOUCHER_SUCCESS, VOUCHER_ERROR, ERR, CONFIRM, VALUES, ORG, UPT_ORG, ERR_ORG } from "../../constants/alertMessage";

const cookies = new Cookies();
const Voucher = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [assignModalOpen, setAssignModalOpen] = useState(false);
  const [assignDropdownValue, setAssignDropdownValue] = useState("");
  const [voucherId, setVoucherId] = useState(null);
  const [subscription_id, setSubscription] = useState("");
  const [values, setValues] = useState({
    name: "",
    refCode: "",
    limit: "",
    from: "",
    sub_id: "",
    end: "",
    error: false,
    header: "",
    success: false,
    vochers: [],
    sub: [],
    message: "",
    _id: "",
    type: "add",
    removed: false,
    org: [],
  });
  const {
    refCode,
    limit,
    from,
    end,
    sub,
    vochers,
    name,
    success,
    type,
    _id,
    removed,
    org,
  } = values;

  const token = cookies.get("agritech_token");

  useEffect(() => {
    loadData();
    loadOrganisations();
  }, [success, removed]);




  const loadData = () => {
    voucherList("vocher").then((data) => {
      if (data.error) {
        Swal.fire({
          icon: `${ERR}`,
          title: `${ERR_ALERT_TITLE}`,
          text: `${ERR_GETTING}`,
          confirmButtonText: `${CONFIRM}`,
        });
      } else {
        AdminSubscription(token).then((sub) => {
          if (sub.error) {
            Swal.fire({
              icon: `${ERR}`,
              title: `${ERR_ALERT_TITLE}`,
              text: `${ERR_GETTING}`,
              confirmButtonText: `${CONFIRM}`,
            });
          } else {
            setValues((prevValues) => ({
              ...prevValues,
              vochers: data.vocher,
              sub: sub,
              _id: "",
              header: "Create Vocher",
              sub_id: "",
            }));
            console.log(`${VALUES}`, {
              vochers: data.vocher,
              sub: sub,
            });
          }
        });
      }
    });
  };

  const loadOrganisations = () => {
    getOrganisation(token, "All", "All")
      .then((data) => {
        console.log(`${ORG}`, data);
        if (data.error) {
          Swal.fire({
            title: data.error,
            icon: `${ERR}`,
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: `${CONFIRM}`,
          });
        } else {
          setValues((prevValues) => ({
            ...prevValues,
            org: data.org,
          }));
          console.log(`${UPT_ORG}`, data.org);
        }
      })
      .catch((error) => {
        console.error(`${ERR_ORG}`, error);
        Swal.fire({
          title: `${ERR_GETTING}`,
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: `${CONFIRM}`,
        });
      });
  };




  const handleSubmit = (e) => {
    e.preventDefault();
    setValues({ ...values, loading: true, error: false });
    const chapter = { name, refCode, subscription_id, from, end, limit };
    console.log(type, "add or edit");
    if (type === "add") {
      console.log(chapter, "values...");
      addVocher(chapter).then((data) => {
        if (data.error) {
          setValues({
            ...values,
            error: data.error,
            message: data.message,
            loading: false,
          });
          handleClose();
          Swal.fire({
            icon: "error",
            title: `${ERR_ALERT_TITLE}`,
            text: data.message,
          });
        } else {
          Swal.fire({
            title: data.message,
            text: "",
            icon: "success",
            confirmButtonText: "Ok",
            showCancelButton: false,
          });
          handleClose();
          loadData();
        }
      });
    } else if (type === "edit") {
      editVocher(chapter, _id).then((data) => {
        if (data.error) {
          setValues({
            ...values,
            error: data.error,
            message: data.message,
            loading: false,
          });
          handleClose();
          Swal.fire({
            icon: "error",
            title: `${ERR_ALERT_TITLE}`,
            text: data.message,
          });
        } else {
          Swal.fire({
            title: data.message,
            text: "",
            icon: "success",
            confirmButtonText: "Ok",
            showCancelButton: false,
          });
          setVoucherId(null);
          handleClose();
          loadData();
        }
      });
    }
  };

  const handleChange = (name) => (e) => {

    setValues({ ...values, error: false, [name]: e.target.value });
  };
  function handlesubChange(e) {
    setSubscription(e.target.value);
  }

  function Status(cell, row) {
    if (row.deleteStatus) {
      return (
        <span>
          <span className="btn-sm btn-danger">InActive</span>
        </span>
      );
    } else {
      return (
        <span>
          <span className="btn-sm btn-success">Active</span>
        </span>
      );
    }
  }
  const handleClearData = () => {
    setValues({
      ...values,
      name: "",
      refCode: "",
      limit: "",
      from: "",
      end: "",
    });
    setShow(true);
    setVoucherId(null);
  };

  const handleAssignButtonClick = (voucherId) => {
    setAssignModalOpen(true);
    setVoucherId(voucherId);
  };



  const handleAssignDropdownChange = (e) => {
    setAssignDropdownValue(e.target.value);
  };


  const handleAssignModalClose = () => {
    setAssignModalOpen(false);
    setAssignDropdownValue("");
  };


  const handleAssignSubmit = () => {
    const data = {
      vocher_id: voucherId,
      org_id: assignDropdownValue,
    };


    assignVocher(data)
      .then((response) => {

        if (response.error) {
          Swal.fire({
            icon: `${ERR}`,
            title: `${ERR_ALERT_TITLE}`,
            text: response.message,
            confirmButtonText: `${CONFIRM}`,
          });
        } else {
          Swal.fire({
            title: `${VOUCHER_SUCCESS}`,
            text: "",
            icon: "success",
            confirmButtonText: `${CONFIRM}`,
          });
          handleAssignModalClose();
          loadData();
        }
      })
      .catch((error) => {
        console.error(`${VOUCHER_ERROR}`, error);
        Swal.fire({
          icon: `${ERR}`,
          title: `${ERR_ALERT_TITLE}`,
          text: `${VOUCHER_ERROR}`,
          confirmButtonText: `${CONFIRM}`,
        });
      });
  };



  function Actions({ row }) {
    const handleEditClick = (e) => {
      console.log(row, "specific voucher");
      setValues({
        ...values,
        error: false,
        name: row.name,
        header: "Edit Vocher",
        type: "edit",
        _id: row._id,
        sub_name: row.subscription_name,
        sub_id: row.subscription_id,
        subscription_id: row.subscription_id,
        refCode: row.refCode,
        limit: row.limit,
        from: row.from,
        end: row.end,
      });
      setVoucherId(row._id);
      setShow(true);
    };

    const handleClick = (e) => {
      if (row.deleteStatus) {
        Swal.fire({
          title: `Restore Vocher ${row.name} ?`,
          text: "",
          icon: "warning",
          allowOutsideClick: false,
          confirmButtonText: "Yes",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            deleteVocher(row._id, false).then((data) => {
              if (data.error) {
                setValues({ ...values, error: data.error, loading: false });
              } else {
                loadData();
              }
            });
          }
        });
      } else {
        Swal.fire({
          title: `Remove Vocher ${row.name} ?`,
          text: "",
          icon: "question",
          allowOutsideClick: false,
          confirmButtonText: "Yes",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            deleteVocher(row._id, true).then((data) => {
              if (data.error) {
                setValues({ ...values, error: data.error, loading: false });
              } else {
                loadData();
              }
            });
          }
        });
      }
    };
    if (row.deleteStatus) {
      return (
        <span>
          <i className="mr-2" onClick={handleEditClick}>
            <FiEdit2
              size="18px"
              color="#0978F2"
              className="waves-effect waves-light"
              data-tooltip-id="1"
              data-tooltip-content={`${EDIT}`}
            />
          </i>
          <Tooltip id="1" style={{ fontSize: "12px" }} />

          <i className="ml-2" onClick={handleClick}>
            <FaRegThumbsUp
              size="18px"
              color="green"
              data-tooltip-id="3"
              data-tooltip-content="Active"
            />
          </i>
          <Tooltip id="3" style={{ fontSize: "12px" }} />
        </span>
      );
    } else {
      return (
        <span>
          <i className="mr-2" onClick={handleEditClick}>
            <FiEdit2
              size="18px"
              color="#0978F2"
              className="waves-effect waves-light"
              data-tooltip-id="1"
              data-tooltip-content={`${EDIT}`} />
          </i>
          <Tooltip id="1" style={{ fontSize: "12px" }} />
          <i className="ml-2" onClick={handleClick}>
            <FaRegThumbsDown
              size="18px"
              color="red"
              data-tooltip-id="2"
              data-tooltip-content="InActive"
            />
          </i>
          <Tooltip id="2" style={{ fontSize: "12px" }} />
        </span>
      );
    }
  }

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#769A0F" />
      <Sidebar type="settings" />
      <div className="content-page">
        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box">
                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        {" "}
                        <Link to="/dashboard">Dashboard</Link>
                      </li>
                      <li className="breadcrumb-item active">Settings</li>
                      <li className="breadcrumb-item active">Voucher</li>
                    </ol>
                  </div>
                  <h4 className="page-title">Voucher</h4>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card-box">
                  <div style={{ width: "98%" }}>
                    <button
                      className="btn btn-icon waves-effect waves-light btn-primary mb-3"
                      onClick={(e) => handleClearData()}
                    >
                      {" "}
                      <i className="fa fa-plus"></i> Add Voucher
                    </button>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>S.No</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Subscription</TableCell>
                            <TableCell>User Limit</TableCell>
                            <TableCell>Start Date</TableCell>
                            <TableCell>End Date</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {vochers.map((voucher, index) => (
                            <TableRow
                              key={voucher._id}
                              onClick={() =>
                                console.log(voucher, "voucher data..")
                              }
                            >
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{voucher.name}</TableCell>
                              <TableCell>{voucher.subscription_name}</TableCell>
                              <TableCell>{voucher.limit}</TableCell>
                              <TableCell>{voucher.from}</TableCell>
                              <TableCell>{voucher.end}</TableCell>
                              <TableCell>
                                {Status(null, {
                                  deleteStatus: voucher.deleteStatus,
                                })}
                              </TableCell>
                              <TableCell>
                                <Actions row={voucher} />
                                <Button
                                  sx={{
                                    backgroundColor: "#769A0F",
                                    color: "#ffffff",
                                    border: "1px solid #769A0F",
                                    borderRadius: "4px",
                                    padding: "4px 8px",
                                    marginLeft: "20px",
                                    cursor: "pointer",
                                    textTransform: "none",
                                    "&:hover": {
                                      backgroundColor: "#769A0F",
                                    },
                                  }}
                                  aria-controls="assign-menu"
                                  aria-haspopup="true"
                                  onClick={() => handleAssignButtonClick(voucher?._id)}
                                >
                                  Assign
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={show}
        onClose={handleClose}
        aria-labelledby="add-voucher-modal-title"
        aria-describedby="add-voucher-modal-description"
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "100px",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "900px",
            height: "auto",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: 24,
            outline: "none",
          }}
        >
          <h3>{voucherId ? "Edit Voucher" : "Add Voucher"}</h3>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item md={6} xs={12}>
                <TextField
                  label="Name"
                  value={name}
                  placeholder="Enter name"
                  onChange={handleChange("name")}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <FormControl fullWidth required>
                  <InputLabel id="subscription-label">Subscription</InputLabel>
                  <Select
                    labelId="subscription-label"
                    id="sub_id"
                    value={subscription_id}
                    onChange={handlesubChange}
                  >
                    {sub.map((item) => (
                      <MenuItem key={item._id} value={item.subscription_id}>
                        {item.name} {item.validity} days
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  label="User Limit"
                  type="number"
                  value={limit}
                  placeholder="Enter User limit"
                  onChange={handleChange("limit")}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  label="Valid Start Date"
                  type="date"
                  value={from}
                  placeholder="Start Date"
                  onChange={handleChange("from")}
                  required
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  label="Valid End Date"
                  type="date"
                  value={end}
                  placeholder="End Date"
                  onChange={handleChange("end")}
                  required
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              justifyContent="flex-end"
              style={{ marginTop: "20px" }}
            >
              <Grid item>
                <Button variant="outlined" color="error" onClick={handleClose}>
                  Close
                </Button>
              </Grid>
              <Grid item>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    backgroundColor: "#769A0F",
                    color: "#fff",
                  }}
                >
                  {voucherId ? "Update" : "Submit"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>


      <Modal
        open={assignModalOpen}
        onClose={handleAssignModalClose}
        aria-labelledby="assign-modal-title"
        aria-describedby="assign-modal-description"
        BackdropProps={{
          sx: { backgroundColor: "transparent" },
        }}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            width: "500px",
            height: "auto",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: 24,
            outline: "none",
          }}
        >
          <h3>Assign Voucher</h3>
          <FormControl fullWidth>
            <InputLabel id="assign-dropdown-label">Assign To</InputLabel>
            <Select
              labelId="assign-dropdown-label"
              id="assign-dropdown"
              value={assignDropdownValue}
              onChange={handleAssignDropdownChange}
            >

              {org.map((item) => (
                <MenuItem key={item._id} value={item._id}>
                  {item.displayName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>


          <Grid
            container
            justifyContent="flex-end"
            style={{ marginTop: "20px" }}
          >
            <Button
              variant="outlined"
              color="error"
              onClick={handleAssignModalClose}
              style={{ marginRight: "10px" }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#769A0F", color: "#fff" }}
              // Add onClick function to handle assignment
              onClick={handleAssignSubmit}
            >
              Assign
            </Button>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default Voucher;

